
import { Link } from 'react-router-dom';
import videos from "./data.json"



const StudentVideos = () => {

    const filtered_videos = videos.filter(video => video.type == "student")

    return (  
        <div className="allvideos">
            <h1>Student Videos</h1>


            {filtered_videos && filtered_videos.map((video) => (
                <div className="repo-preview" key={video.id}>
                    <Link to={`/allvideos/${video.id}`}>
                    <h2>{video.title}</h2>
                    </Link>

                </div>
            ))}
        </div>
    );

}

export default StudentVideos;